var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#AD0303"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.968 6.544C4.92 5.856 4.864 4.168 4.864 3.096V2.16H5.328V3.096C5.328 4.168 5.28 5.856 5.232 6.544H4.968ZM4.672 7.648C4.672 7.416 4.864 7.232 5.088 7.232C5.328 7.232 5.512 7.416 5.512 7.648C5.512 7.888 5.328 8.08 5.088 8.08C4.848 8.08 4.672 7.888 4.672 7.648Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateErrorIcon);
export default __webpack_public_path__ + "static/media/Date_Error_Icon.b668c16cf4b985df0772442a8b0c2dfd.svg";
export { ForwardRef as ReactComponent };